import store from '../store';
import Communications from '../views/communication/Index.vue';
import { checkauth } from '../Helper';

export default [
	{
		path: '/communications',
		name: 'communication',
		component: Communications,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				// console.log(response)
				if (response) {
					//console.log("login")
					next();
				} else {
					//console.log("next")
					next('/login');
				}
			});
		},
	},
];
